var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadimg = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_561_47583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_561_47583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 40C9.96667 40 7.375 38.95 5.225 36.85C3.075 34.75 2 32.1833 2 29.15C2 26.55 2.78333 24.2333 4.35 22.2C5.91667 20.1667 7.96667 18.8667 10.5 18.3C11.3333 15.2333 13 12.75 15.5 10.85C18 8.95 20.8333 8 24 8C27.9 8 31.2083 9.35833 33.925 12.075C36.6417 14.7917 38 18.1 38 22C40.3 22.2667 42.2083 23.2583 43.725 24.975C45.2417 26.6917 46 28.7 46 31C46 33.5 45.125 35.625 43.375 37.375C41.625 39.125 39.5 40 37 40H26V25.7L27.8 27.45C28.1667 27.8167 28.625 28 29.175 28C29.725 28 30.2 27.8 30.6 27.4C30.9667 27.0333 31.15 26.5667 31.15 26C31.15 25.4333 30.9667 24.9667 30.6 24.6L25.4 19.4C25 19 24.5333 18.8 24 18.8C23.4667 18.8 23 19 22.6 19.4L17.4 24.6C17.0333 24.9667 16.8417 25.425 16.825 25.975C16.8083 26.525 17 27 17.4 27.4C17.7667 27.7667 18.225 27.9583 18.775 27.975C19.325 27.9917 19.8 27.8167 20.2 27.45L22 25.7V40H13Z",
    fill: "#929292"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadimg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uploadimg.6a9c60bd80610647901d8a3c17933b06.svg";